const tabs = document.querySelectorAll('.area-button');
const mainWrapper = document.querySelectorAll('.area-sections-wrapper');

if (tabs.length === 0 || mainWrapper.length === 0) {
    console.error('Elements not found!');
} else {
    let currentId = null; 

    const initializeTabs = () => {
        if (mainWrapper.length > 0) {
            const firstSection = mainWrapper[0];
            firstSection.style.display = 'block';
            firstSection.style.opacity = '1';
            currentId = firstSection.dataset.id;

            mainWrapper.forEach((section, index) => {
                if (index !== 0) {
                    section.style.display = 'none';
                    section.style.opacity = '0';
                }
            });

            tabs.forEach((tab) => {
                const buttons = tab.querySelectorAll('.btn');
                buttons.forEach((button, index) => {
                    if (index === 0) {
                        button.classList.add('active');
                    } else {
                        button.classList.remove('active');
                    }
                });
            });
        }
    };


    const switchTab = (targetId) => {
        if (targetId === currentId) return;

        const targetSection = Array.from(mainWrapper).find(section => section.dataset.id === targetId);
        const currentSection = Array.from(mainWrapper).find(section => section.dataset.id === currentId);

        if (!targetSection) {
            console.error('Target section not found!');
            return;
        }

        const transitionDuration = 300;

        if (currentSection) {
            currentSection.style.opacity = '0';
            setTimeout(() => {
                currentSection.style.display = 'none';

                targetSection.style.display = 'block';
                targetSection.style.opacity = '0';
                setTimeout(() => {
                    targetSection.style.opacity = '1';
                }, 10); 
            }, transitionDuration);
        } else {

            targetSection.style.display = 'block';
            targetSection.style.opacity = '1';
        }
        currentId = targetId;
    };

    initializeTabs();

    tabs.forEach((tab) => {
        const buttons = tab.querySelectorAll('.btn');
        
        if (buttons.length === 0) {
            console.error('No .btn elements found in tab');
            return;
        }

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const clickedId = button.dataset.id;
                console.log('Clicked button ID:', clickedId);
                switchTab(clickedId);

                buttons.forEach((btn) => {
                    if (btn.dataset.id === clickedId) {
                        btn.classList.add('active');
                    } else {
                        btn.classList.remove('active');
                    }
                });
            });
        });
    });
}